export const monthsLowerCase = [
  "jan", "feb", "mar", "apr", "may", "jun",
  "jul", "aug", "sep", "oct", "nov", "dec"
];

export const monthsUpperCase = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export const defaultAllocation = {
    "jan": 8.33,
    "feb": 8.33,
    "mar": 8.33,
    "apr": 8.33,
    "may": 8.33,
    "jun": 8.33,
    "jul": 8.33,
    "aug": 8.33,
    "sep": 8.33,
    "oct": 8.33,
    "nov": 8.33,
    "dec": 8.37,
};

export const defaultAdSpendAllocations = [
    { id: 1, name: "Meta", percentage: 35 },
    { id: 2, name: "Google", percentage: 25 },
    { id: 3, name: "Amazon PPC", percentage: 15 },
    { id: 4, name: "Applovin", percentage: 10 },
    { id: 5, name: "Snapchat", percentage: 8 },
    { id: 6, name: "TikTok", percentage: 7 },
];

export const defaultMonthlySummary = { 
                    "aov": {
                        "jan": 0,
                        "feb": 0,
                        "mar": 0,
                        "apr": 0,
                        "may": 0,
                        "jun": 0,
                        "jul": 0,
                        "aug": 0,
                        "sep": 0,
                        "oct": 0,
                        "nov": 0,
                        "dec": 0
                    },
                    "ad_spend": {
                        "jan": 0,
                        "feb": 0,
                        "mar": 0,
                        "apr": 0,
                        "may": 0,
                        "jun": 0,
                        "jul": 0,
                        "aug": 0,
                        "sep": 0,
                        "oct": 0,
                        "nov": 0,
                        "dec": 0
                    },
                    "mer": {
                        "jan": 0,
                        "feb": 0,
                        "mar": 0,
                        "apr": 0,
                        "may": 0,
                        "jun": 0,
                        "jul": 0,
                        "aug": 0,
                        "sep": 0,
                        "oct": 0,
                        "nov": 0,
                        "dec": 0
                    },
                    "total_revenue": {
                        "jan": 0,
                        "feb": 0,
                        "mar": 0,
                        "apr": 0,
                        "may": 0,
                        "jun": 0,
                        "jul": 0,
                        "aug": 0,
                        "sep": 0,
                        "oct": 0,
                        "nov": 0,
                        "dec": 0
                    },
                    "total_units": {
                        "jan": 0,
                        "feb": 0,
                        "mar": 0,
                        "apr": 0,
                        "may": 0,
                        "jun": 0,
                        "jul": 0,
                        "aug": 0,
                        "sep": 0,
                        "oct": 0,
                        "nov": 0,
                        "dec": 0
                    },
                    "shopify": {
                        "jan": 0,
                        "feb": 0,
                        "mar": 0,
                        "apr": 0,
                        "may": 0,
                        "jun": 0,
                        "jul": 0,
                        "aug": 0,
                        "sep": 0,
                        "oct": 0,
                        "nov": 0,
                        "dec": 0
                    },
                    "amazon": {
                        "jan": 0,
                        "feb": 0,
                        "mar": 0,
                        "apr": 0,
                        "may": 0,
                        "jun": 0,
                        "jul": 0,
                        "aug": 0,
                        "sep": 0,
                        "oct": 0,
                        "nov": 0,
                        "dec": 0
                    },
                    "wholesale": {
                        "jan": 0,
                        "feb": 0,
                        "mar": 0,
                        "apr": 0,
                        "may": 0,
                        "jun": 0,
                        "jul": 0,
                        "aug": 0,
                        "sep": 0,
                        "oct": 0,
                        "nov": 0,
                        "dec": 0
                    }
                }